import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Animated, View, Image } from "react-native";
export * from "./types";
export { default as useTransitionProgress } from "./useTransitionProgress";
export { isSearchBarAvailableForCurrentPlatform, isNewBackTitleImplementation, executeNativeBackPress } from "./utils";
var ENABLE_SCREENS = true;
export function enableScreens() {
    var shouldEnableScreens = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    ENABLE_SCREENS = shouldEnableScreens;
}
export function screensEnabled() {
    return ENABLE_SCREENS;
}
// @ts-ignore function stub, freezing logic is located in index.native.tsx
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function enableFreeze() {
    var shouldEnableReactFreeze = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
// noop
}
export var NativeScreen = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(NativeScreen, _React_Component);
    var _super = _create_super(NativeScreen);
    function NativeScreen() {
        _class_call_check(this, NativeScreen);
        return _super.apply(this, arguments);
    }
    _create_class(NativeScreen, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, active = _this_props.active, activityState = _this_props.activityState, style = _this_props.style, _this_props_enabled = _this_props.enabled, enabled = _this_props_enabled === void 0 ? ENABLE_SCREENS : _this_props_enabled, rest = _object_without_properties(_this_props, [
                    "active",
                    "activityState",
                    "style",
                    "enabled"
                ]);
                if (enabled) {
                    if (active !== undefined && activityState === undefined) {
                        activityState = active !== 0 ? 2 : 0; // change taken from index.native.tsx
                    }
                    return /*#__PURE__*/ _jsx(View, _object_spread({
                        // @ts-expect-error: hidden exists on web, but not in React Native
                        hidden: activityState === 0,
                        style: [
                            style,
                            {
                                display: activityState !== 0 ? "flex" : "none"
                            }
                        ]
                    }, rest));
                }
                return /*#__PURE__*/ _jsx(View, _object_spread({}, rest));
            }
        }
    ]);
    return NativeScreen;
}(React.Component);
export var Screen = Animated.createAnimatedComponent(NativeScreen);
export var InnerScreen = View;
export var ScreenContext = /*#__PURE__*/ React.createContext(Screen);
export var ScreenContainer = View;
export var NativeScreenContainer = View;
export var NativeScreenNavigationContainer = View;
export var ScreenStack = View;
export var FullWindowOverlay = View;
export var ScreenStackHeaderBackButtonImage = function(props) {
    return /*#__PURE__*/ _jsx(View, {
        children: /*#__PURE__*/ _jsx(Image, _object_spread({
            resizeMode: "center",
            fadeDuration: 0
        }, props))
    });
};
export var ScreenStackHeaderRightView = function(props) {
    return /*#__PURE__*/ _jsx(View, _object_spread({}, props));
};
export var ScreenStackHeaderLeftView = function(props) {
    return /*#__PURE__*/ _jsx(View, _object_spread({}, props));
};
export var ScreenStackHeaderCenterView = function(props) {
    return /*#__PURE__*/ _jsx(View, _object_spread({}, props));
};
export var ScreenStackHeaderSearchBarView = function(props) {
    return /*#__PURE__*/ _jsx(View, _object_spread({}, props));
};
export var ScreenStackHeaderConfig = function(props) {
    return /*#__PURE__*/ _jsx(View, _object_spread({}, props));
};
// @ts-expect-error: search bar props have no common props with View
export var SearchBar = View;
export var ScreenStackHeaderSubview = View;
export var shouldUseActivityState = true;
